import { between, changeSelectOptions, setCss, debounce, setLoading, getSelectValues, tryJsonParse } from './functions.js';

export default function Step2Module(element) {

    let weeklyGasAmountSelect = element.querySelector('select[name=weekly_gas_expense]');
    let kmUrbanInput = element.querySelector('input[name=weekly_km_urban]');
    let kmHighwayInput = element.querySelector('input[name=weekly_km_highway]');
    let submitBtn = element.querySelector('#js-btn-submit');
    let noResults = element.querySelector('#js-no-results');
    let willDoLongTripsInput = element.querySelector('input[type=checkbox][name=will_do_long_trips]');

    let countCountainer = element.querySelector('#js-resulting-cars');

    let loadingCountContainer = element.querySelector('.carsearch__results__number');

    element.addEventListener('change', event => {
        if (!event.target.matches('.js-trigger-filter')) {
            return;
        }
        debounceCountCars();
    });
    element.addEventListener('input', event => {
        if (!event.target.matches('.js-trigger-filter')) {
            return;
        }
        debounceCountCars();
    });

    element.addEventListener('change', event => {
        if (!event.target.matches('[name=weekly_km_urban], [name=weekly_km_highway]')) {
            return;
        }
        refreshExpenseRanges();
        
    });

    willDoLongTripsInput.addEventListener('click', event => {
        showHideMicrocoches();
    });

    function countCars() {
        const data = new FormData(element);
        data.append('action', 'countCars');
        data.append('uuid', window.UUID);

        setLoading(loadingCountContainer, true);

        fetch(window.WP_ADMIN_URL + 'admin-ajax.php', {
            method: 'POST',
            body: data
        })
        .then(response => response.json())
        .then(function(res) {
            countCountainer.innerText = res.count;

            setLoading(loadingCountContainer, false);

            if (res.count === 0) {
                submitBtn.disabled = true;
                setCss(noResults, 'display', 'block')
            } else {
                submitBtn.disabled = false;
                setCss(noResults, 'display', 'none')
            }
            
        }).catch(function(err) {
            setLoading(loadingCountContainer, false);
            console.error(err);
        });
    }

    let debounceCountCars = debounce(countCars, 500);

    function refreshExpenseRanges() {
        let sum = parseInt(kmUrbanInput.value, 10) + parseInt(kmHighwayInput.value, 10);

        let expenseRanges = getExpensesRangesForKms(sum);

        expenseRanges = expenseRanges.map(function(range) {
            let [min, max] = range.split('-');
            
            let label = 'entre ' + min + ' y ' + max + ' €';
            
            return {
                value: range,
                label: label,
            }
        });

        expenseRanges.unshift({value:'', label:'Selecciona...'})

        changeSelectOptions(weeklyGasAmountSelect, expenseRanges)
        weeklyGasAmountSelect.disabled = false;
        
    }

    function showHideMicrocoches() {
        console.log('will_do_long_trips');

        let select  = element.querySelector('select[name*=car_type]');
        let choicesInstance = select.choicesInstance;

        if (!choicesInstance) {
            setTimeout(showHideMicrocoches, 200);
            return;
        }

        let values = getSelectValues(select);

        let allChoices = tryJsonParse(select.dataset.choices);
        if (willDoLongTripsInput.checked) {
            allChoices = allChoices.filter(d => d.value !== 'Microcoche')
        }

        allChoices.forEach(choice => {
            choice.selected = values.includes(choice.value);
        });

        choicesInstance.clearStore();
        choicesInstance.setChoices(allChoices, 'value', 'label', true);
    }

    showHideMicrocoches();
    refreshExpenseRanges();
    countCars();

    setTimeout(function() {
        weeklyGasAmountSelect.kdModule.loadInitialValue();
    }, 1);

    return this;

}

function getExpensesRangesForKms(kms) {
    
    let ranges = [
        // kms,     ...range for expenses
        ['0-50',	'0-3',	    '3-5',	    '5-10'],
        ['51-100',	'0-5',	    '5-10',	    '10-15'],
        ['101-150',	'5-10',	    '10-15',	'15-20'],
        ['151-200',	'5-10',	    '10-20',	'20-27'],
        ['201-250',	'10-15',	'15-25',	'25-35'],
        ['251-300',	'10-20',	'20-30',	'30-40'],
        ['301-350',	'10-20',	'20-30',	'30-45'],
        ['351-400',	'15-25',	'25-35',	'35-55'],
        ['401-450',	'20-30',	'30-40',	'40-60'],
        ['451-500',	'25-35',	'35-50',	'50-65'],
        ['501-550',	'30-40',	'40-50',	'50-70'],
        ['551-600',	'30-45',	'45-55',	'55-75'],
    ];

    for (let i in ranges) {
        let range = ranges[i];
        let rangeKms = range.shift();
        let [min, max] = rangeKms.split('-');

        min = parseInt(min, 10);
        max = parseInt(max, 10);

        if (between(kms, min, max)) {
            return range;
        }
    }

    return ['45-55', '55-75', '75-85'];
}